export type TStaticContentLinkTarget = { kind: 'ref'; value: string } | { kind: 'scroll'; value: string };

/** The target of a click on a reference or scroll link in content the doc-engine rendered as static html. */
export const resolveStaticContentLinkTarget = (eventTarget: EventTarget | null): TStaticContentLinkTarget | null => {
  if (!(eventTarget instanceof Element)) return null;

  const anchor = eventTarget.closest('a[href^="#"]');
  if (anchor) {
    const value = anchor.getAttribute('href')?.slice(1);
    return value ? { kind: 'ref', value } : null;
  }

  const scrollLink = eventTarget.closest('[data-target-id]');
  if (scrollLink) {
    const value = scrollLink.getAttribute('data-target-id');
    return value ? { kind: 'scroll', value } : null;
  }

  return null;
};
